import React from 'react'
import {
  ArrayInput,
  FormDataConsumer,
  NumberInput,
  SimpleFormIterator,
  useTranslate,
} from 'react-admin'
import {
  Transaction,
  TransactionCustomization,
} from 'services/api/entities/accounting/transaction/types/internal/transaction-models'
import { useLangContext } from 'services/contexts/LangContext'
import { parseMultilang } from 'services/utils/multilangParseWrite'
import { FormDataConsumerProps } from 'types/common'
import KAccordion from 'ui-shared/accordions/KAccordion'

const TransactionCustomizationsInput: React.FC = () => {
  const translate = useTranslate()
  const { currentLang } = useLangContext()

  return (
    <KAccordion
      accordionTitle={translate('form.headers.transactionCustomizations')}
    >
      <ArrayInput source="customizations">
        <SimpleFormIterator disableAdd disableRemove disableReordering>
          <FormDataConsumer>
            {({
              scopedFormData,
              getSource,
            }: FormDataConsumerProps<
              Transaction,
              TransactionCustomization
            >) => {
              const translatedCustomizationName = parseMultilang(currentLang)(
                scopedFormData?.name
              )

              return (
                <>
                  {translatedCustomizationName && (
                    <div style={{ margin: '12px 0px' }}>
                      {translatedCustomizationName}
                    </div>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '24px',
                    }}
                  >
                    <NumberInput
                      source={getSource!('price')}
                      label="form.fields.customizationPrice"
                    />
                    <NumberInput
                      source={getSource!('cost')}
                      label="form.fields.customizationCost"
                    />
                  </div>
                </>
              )
            }}
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>
    </KAccordion>
  )
}

export default TransactionCustomizationsInput
